import { ControlledDateOnlyPicker, ControlledSelect, ControlledTextField, FieldGrid, useFormDialog } from '@if/mui'
import { getToday } from '@src/services/DateTimeProvider'
import { useTranslatedMetro2ReportingReasonList } from '@src/types/constants'
import { Metro2Reporting } from '@src/types/loan/loan-calendar'
import { CalendarCog } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { getFirstDayOfCurrentMonth, Metro2ReportingSchema, Metro2ReportingSchemaType } from './Metro2Reporting-schema'

/**
 * Collects one bureau-reporting record. It posts nothing: the reporting dialog above takes the
 * answer, stages it as the current record and saves it when the agent confirms there.
 */
export const useEditMetro2ReportingDialog = () => {
  const { t } = useTranslation()
  const reasonOptions = useTranslatedMetro2ReportingReasonList()

  return useFormDialog<Metro2ReportingSchemaType, Metro2Reporting | null>({
    icon: CalendarCog,
    title: {
      create: t('loan.payment.creditReportDialog.addDate'),
      edit: t('loan.payment.creditReportDialog.editDate'),
    },
    confirmLabel: t('common.confirm'),
    maxWidth: 'sm',
    fullWidth: true,
    schema: Metro2ReportingSchema,
    successMessage: false,
    defaultValues: (reporting) => ({
      metro2OverrideDate: reporting?.metro2OverrideDate ?? getToday(),
      metro2ReportingReason: reporting?.metro2ReportingReason,
      description: reporting?.description ?? '',
    }),
    content: ({ form }) => (
      <FieldGrid columns={{ xs: 1, sm: 2 }}>
        <ControlledDateOnlyPicker
          control={form.control}
          name="metro2OverrideDate"
          label={t('loan.payment.creditReportDialog.date')}
          minDate={getFirstDayOfCurrentMonth()}
        />
        <ControlledSelect
          control={form.control}
          name="metro2ReportingReason"
          options={reasonOptions}
          label={t('loan.payment.creditReportDialog.reason')}
          disableEmptyOption
        />
        <ControlledTextField
          control={form.control}
          name="description"
          label={t('loan.payment.creditReportDialog.desc')}
          multiline
          rows={4}
          span="full"
        />
      </FieldGrid>
    ),
  })
}
